export default function Action() {
  return function MethodDecorator(
    target: Function,
    ctx: ClassMethodDecoratorContext
  ) {
    const methodName = ctx.name.toString();

    ctx.addInitializer(function () {
      // store information that this field is observed
      if ((this as any).__actionFields === undefined) {
        (this as any).__actionFields = new Set();
      }

      (this as any).__actionFields.add(methodName);
    });
  };
}
